import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../redux/reducers';
import { DashboardComponent } from '../../components/Dashboard/Dashboard.Component';

// styles
import './PrincipalPage.css';

/** Fecha de hoy en el idioma de la interfaz ("jueves, 15 de octubre de 2026"). */
export const formatToday = (language: string | undefined, now: Date = new Date()): string => {
  try {
    return now.toLocaleDateString(language || 'es', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return now.toLocaleDateString();
  }
};

/** Pantalla inicial: saludo y panel configurable de widgets (ver components/Dashboard). */
export const PrincipalPage = () => {
  const { t, i18n } = useTranslation();
  const givenName = useSelector((state: AppState) => state.oidc?.user?.profile?.given_name as string | undefined);

  const heading = (
    <div className="principal__heading">
      <h1 className="principal__title" data-testid="principal-greeting">
        {t('dashboard.greeting', { name: givenName || '' }).trim().replace(/,\s*$/, '')}
      </h1>
      <span className="principal__subtitle">{formatToday(i18n.language)}</span>
    </div>
  );

  return (
    <div className="principal">
      <DashboardComponent heading={heading} />
    </div>
  );
};

export default PrincipalPage;
